import { render, staticRenderFns } from "./Vtex.vue?vue&type=template&id=5c8bc6de"
import script from "./Vtex.vue?vue&type=script&lang=js"
export * from "./Vtex.vue?vue&type=script&lang=js"
import style0 from "./Vtex.vue?vue&type=style&index=0&id=5c8bc6de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports